import { motion } from 'framer-motion'
import type { Hero as HeroType } from '../types/content'

interface HeroProps {
  data: HeroType
}

export default function Hero({ data }: HeroProps) {
  return (
    <section
      id="hero"
      className="min-h-screen flex items-center justify-center text-center pt-20 relative overflow-hidden bg-grid"
    >
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-glow pointer-events-none" />

      {/* Secondary glow */}
      <div className="absolute top-1/4 right-1/4 w-[400px] h-[400px] bg-gradient-to-br from-secondary/5 to-transparent rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-4xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="inline-block px-4 py-1.5 mb-6 text-sm bg-gradient-card border border-border rounded-full text-gray-300"
        >
          {data.subtitle}
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-gradient"
        >
          {data.title}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto"
        >
          {data.description}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-wrap gap-4 justify-center"
        >
          <a href={data.cta.primary.href} className="btn btn-primary">
            {data.cta.primary.text}
          </a>
          <a href={data.cta.secondary.href} className="btn btn-secondary">
            {data.cta.secondary.text}
          </a>
        </motion.div>
      </div>
    </section>
  )
}
